// DatePickerComponent.js
import { useState, useEffect } from "react";
import { IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import '../assets/DatePickerComponent.css';
import { HolidayDates } from "../constants";

const DatePickerComponent = ({ onDateSelect, onBack }) => {
  const [selectedDate, setSelectedDate] = useState(null);

  // Convert to Date objects for easy comparison
  const holidayDatesSet = new Set(HolidayDates.map((d) => new Date(d).toDateString()));

  const handleDateChange = (date) => {
    setSelectedDate(date);
    onDateSelect(date);
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <div className="flex flex-col items-center p-4">
      <div className="text-amber-500">
        Prices differ from the regular rates on Fridays, weekends, and public holidays
      </div>
      <div className="my-6">
        <div className="bg-white p-3 rounded-lg shadow-md mb-2 w-full max-w-md">
          <div className="flex gap-4 text-sm">
            <div className="flex items-center gap-2">
              <span className="block w-4 h-4 bg-red-400 rounded-full"></span>
              <span className="text-gray-700">Holiday</span>
            </div>

            <div className="flex items-center gap-2">
              <span className="block w-4 h-4 bg-amber-300 rounded-full"></span>
              <span className="text-gray-700">Weekend</span>
            </div>
          </div>
        </div>
        <DatePicker
          selected={selectedDate}
          onChange={handleDateChange}
          dateFormat="MMMM d, yyyy"
          minDate={new Date()}
          placeholderText="Select a date"
          className="border border-gray-300 rounded-lg p-2 shadow-sm focus:outline-none"
          inline
          dayClassName={(date) => {
            const isWeekend =
              date.getDay() === 5 || // Friday
              date.getDay() === 6 || // Saturday
              date.getDay() === 0;   // Sunday

            const isHoliday = holidayDatesSet.has(date.toDateString());

            if (isHoliday) return "holiday-day";
            if (isWeekend) return "weekend-day";

            return "";
          }}
        />
      </div>
      <IconButton
        onClick={onBack}
        sx={{
          position: "fixed",
          top: "18px",
          left: 12,
          height: "34px",
          width: "34px",
          color: "#1f2937",
          backgroundColor: "rgba(255,255,255,0.8)",
          backdropFilter: "blur(6px)",
          boxShadow: 2,
          zIndex: 900,
          "&:hover": { backgroundColor: "#fff" },
        }}
      >
        <ArrowBackIcon />
      </IconButton>
      {/* <Button variant="outlined" color="#1f2937" onClick={onBack}>
        Back
      </Button> */}
    </div>
  );
};

export default DatePickerComponent;
